// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edit-package-modal[data-v-77e0e00c]{border-radius:15px}.edit-package-item__card[data-v-77e0e00c]{max-height:min(92vh,900px);overflow-y:auto;padding-bottom:24px}.edit-package-item__form-body[data-v-77e0e00c]{max-width:100%;min-width:0}", ""]);
// Exports
module.exports = exports;
